/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import Logo from "../../Images/Logo.svg";
import { styles } from "./styles";
import React, { useState, useEffect } from "react";

const calculateTotal = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return 0;
  }

  return rows.reduce((total, row) => total + row.total, 0);
};

const Quotationfile = ({
  customerData,
  editableTotalAmount,
  editableAmountPayable,
  quotationId,
}) => {
  const [currentDate, setCurrentDate] = useState("");
  const [rows, setRows] = useState([
    { description: "", quantity: 0, unitPrice: 0, total: 0 },
  ]);

  const handleInputChange = (index, field, value) => {
    const newRows = [...rows];
    newRows[index][field] = value;

    if (field === "quantity" || field === "unitPrice") {
      newRows[index].total = newRows[index].quantity * newRows[index].unitPrice;
    }

    setRows(newRows);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic here
    const totalAmount = calculateTotal(rows);

    console.log("Form submitted with the following data:");
    console.log({
      quotationId,
      fullName: customerData.fullName,
      phoneNumber: customerData.phoneNumber,
      postCode: customerData.postCode,
      serviceType: customerData.serviceType,
      totalAmount,
    });

    // Additional submission logic here
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      { description: "", quantity: 0, unitPrice: 0, total: 0 },
    ]);
  };

  const handleRemoveRow = (index) => {
    const newRows = rows.filter((row, rowIndex) => rowIndex !== index);
    setRows(newRows);
  };

  useEffect(() => {
    // Function to get current date in "23rd, March, 2024" format
    const getCurrentDate = () => {
      const date = new Date();
      const options = { year: "numeric", month: "long" };
      const formattedDate = date.toLocaleDateString("en-US", options);

      // Convert day number to ordinal (e.g., 23rd, March, 2024)
      const day = date.getDate();
      const suffix =
        day % 10 === 1 && day !== 11
          ? "st"
          : day % 10 === 2 && day !== 12
          ? "nd"
          : day % 10 === 3 && day !== 13
          ? "rd"
          : "th";

      return `${day}${suffix}, ${formattedDate}`;
    };

    setCurrentDate(getCurrentDate());
  }, []); // Empty dependency array ensures this runs only once on component mount

  return (
    <div className="container mx-auto p-4">
      <div className="mx-5 mt-4 p-11 border border-black">
        <div className="flex p-5 flex-wrap">
          <div className="w-full md:w-36 h-36 relative m-0.5 border-1.3 border-black border-opacity-8 bg-gray-100 rounded-full">
            <div className="absolute top-9 w-full">
              <img src={Logo} alt="Logo" className="w-full" />
            </div>
          </div>
          <div
            className="flex-grow p-5 w-full md:w-auto text-center md:text-left"
            style={styles.robotoCenter}
          >
            <div className="flex justify-center md:justify-start">
              <div className="w-60">
                <h6 className="text-xl font-semibold text-blue-700">
                  PMC Project Ltd
                </h6>
              </div>
            </div>
            <div className="mt-6">
              <div className="text-base font-normal text-right">
                {quotationId}
              </div>
            </div>
            <div
              className="border-y-2 border-gray-400 border-opacity-50 py-5 text-gray-700 text-opacity-50 text-base font-normal"
              style={styles.robotoText}
            >
              Kitchen Planning | Design | Assembly | Installation and Repairs |
              Property Renovation | Waste Removal | Deliveries
            </div>
            <div className="flex border-b-2 border-gray-400 border-opacity-50 p-3 flex-wrap">
              <div className="flex p-1.5 w-full md:w-auto">
                {/* Contact Information */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  className="w-7 h-7"
                >
                  <path
                    fill="#718096"
                    d="M8.742 8.682c-1.073.912-1.466 2.575-.54 3.909a12.818 12.818 0 0 0 3.208 3.207c1.334.926 2.997.533 3.909-.54l.01.005A13.38 13.38 0 0 0 19 16.36V19h-.004C11.022 19.011 4.991 12.911 5 5.004V5h2.64v.001c.188 1.27.558 2.506 1.097 3.67l.005.01ZM19 21h1a1 1 0 0 0 1-1v-4.502a1 1 0 0 0-.853-.99l-.854-.126a11.416 11.416 0 0 1-3.123-.934l-.753-.349a1 1 0 0 0-1.234.326l-.341.477c-.299.419-.87.546-1.291.253a10.819 10.819 0 0 1-2.706-2.705c-.293-.422-.165-.993.253-1.291l.477-.34a1 1 0 0 0 .326-1.235l-.35-.754a11.424 11.424 0 0 1-.933-3.123l-.127-.854A1 1 0 0 0 8.501 3H4a1 1 0 0 0-1 1v1.001C2.99 14.008 9.91 21.013 18.999 21Z"
                  />
                </svg>
                <div
                  className="py-1.5 ml-3 text-base font-normal text-gray-700 text-opacity-50"
                  style={styles.robotoCenter}
                >
                  +447916743112
                </div>
              </div>
              <div className="flex p-1.5 w-full md:w-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                  className="w-7 h-7"
                >
                  <path
                    fill="#718096"
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7M7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9"
                  />
                  <circle cx="12" cy="9" r="2.5" fill="#718096" />
                </svg>
                <div
                  className="py-1.5 ml-3 text-base font-normal text-gray-700 text-opacity-50"
                  style={styles.robotoCenter}
                >
                  25 Edgehill Road, Leicester LE4 9EA
                </div>
              </div>
            </div>
          </div>

          {/* Customer and invoice details */}
          <div className="flex flex-wrap mt-4">
            <div className="w-full md:w-1/4 p-3">
              <div className="p-1.6">
                <div className="text-base font-bold" style={styles.robotoText}>
                  CUSTOMER
                </div>
                <div
                  className="text-base font-normal mt-1"
                  style={styles.robotoText}
                >
                  {customerData.fullName}
                </div>
              </div>
              <div
                className="py-0 px-1.5 mt-10 text-base font-bold"
                style={styles.robotoText}
              >
                DATE
              </div>
              <div
                className="py-0 px-1.5 mt-10 text-base font-bold"
                style={styles.robotoText}
              >
                POST CODE
              </div>
              <div
                className="py-0 px-1.5 mt-10 text-base font-bold"
                style={styles.robotoText}
              >
                PHONE
              </div>
              <div
                className="py-0 px-1.5 mt-10 text-base font-bold"
                style={styles.robotoText}
              >
                Total Amount
              </div>
              <div
                className="py-0 px-1.5 mt-10 text-base font-bold"
                style={styles.robotoText}
              >
                Balance Payable
              </div>
            </div>

            <div className="w-full md:w-1/4 p-3">
              <div className="text-base font-bold" style={styles.robotoText}>
                UNIT
              </div>
              <div
                className="text-base font-normal mt-1"
                style={styles.robotoText}
              >
                1
              </div>
            </div>

            <div className="w-full md:w-1/4 p-3">
              <div className="p-1.6">
                <div className="text-base font-bold" style={styles.robotoText}>
                  SERVICE TYPE
                </div>
                <div
                  className="text-base font-normal"
                  style={styles.robotoText}
                >
                  {customerData.serviceType}
                </div>
              </div>
              <div
                className="py-0 px-1.5 text-base font-bold mt-10"
                style={styles.robotoText}
              >
                {currentDate}
              </div>
              <div
                className="px-1.5 py-0 text-base font-bold mt-10"
                style={styles.robotoText}
              >
                {customerData.postCode}
              </div>
              <div
                className="px-1.5 py-0 text-base font-bold mt-10"
                style={styles.robotoText}
              >
                {customerData.phoneNumber}
              </div>
              <div className="flex px-0 py-1.5 mt-10">
                <div
                  className="text-base font-normal mt-1"
                  style={styles.robotoText}
                >
                  {editableTotalAmount}
                </div>
              </div>
              <div className="flex px-0 py-1.5 mt-10">
                <div
                  className="text-base font-normal mt-1"
                  style={styles.robotoText}
                >
                  {editableAmountPayable}
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/4 p-3">
              <div className="text-base font-bold" style={styles.robotoText}>
                Amount
              </div>
              <div
                className="text-base font-normal mt-1"
                style={styles.robotoText}
              >
                {editableTotalAmount}
              </div>
            </div>
          </div>

          {/* Quotation items table */}
          {/* ... (No changes needed here) */}

          {/* Terms */}
          <div className="mt-6">
            <div className="text-base font-semibold mb-2">
              Terms and conditions
            </div>
            <div className="text-base font-normal">
              Please note that payment is due not later than 21 days from the
              invoice date.
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 flex flex-wrap justify-between items-center text-sm text-gray-500">
            <div>PMC Project Ltd, 25 Edgehill Road, Leicester LE4 9EA</div>
            <div>Company No: 12345678 | VAT No: GB987654321</div>
          </div>

          {/* Submit button */}
          <div className="flex justify-center mt-4">
            <button
              type="button"
              onClick={handleSubmit}
              className="px-4 py-2 bg-green-500 text-white rounded"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Quotationfile;
